import { memo } from 'react';
import { Stack } from '@mui/material';

interface IDialogButtonsProps {
  marginTop?: string;
  children?: React.ReactNode;
  justifyContent?: string;
}

function DialogButtons({ marginTop, children, justifyContent = 'space-evenly' }: IDialogButtonsProps) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent={justifyContent}
      spacing="8px"
      sx={{ height: 47, marginTop: marginTop || '40px' }}
    >
      {children}
    </Stack>
  );
}

export default memo(DialogButtons);
